import {
  DISCIPLINE_MEMBERSHIP_FIELDS,
  getHorseNumberFieldName,
  getUserFieldName,
} from './discipline-memberships-const'

import { IReqFieldType } from '../pages/competitor/clinicAndOther/Tabs/components/ProfileFields'

export interface IField {
  title: string
  type: IReqFieldType
  value: string
  img?: string
  discipline?: string
}

// Convert common discipline fields to IField format
const ALL_NUMBERS: IField[] = DISCIPLINE_MEMBERSHIP_FIELDS.map((field) => ({
  title: field.label,
  value: field.key,
  img: field.icon,
  discipline: field.category,
  type: 'number',
}))

interface IRField {
  people: IField[]
  peopleNumbers: IField[]
  horseMain: IField[]
  horseSecondary: IField[]
  horseNumbers: IField[]
}

export const REQUIRED_FIELDS: IRField = {
  people: [
    {
      title: 'Nationality',
      value: 'userNationality',
      type: 'select',
    },
    {
      title: 'Phone number',
      value: 'userPhoneNumber',
      type: 'tel',
    },
    {
      title: 'Discipline',
      value: 'userDiscipline',
      type: 'select',
    },
    {
      title: 'Zone, Region, Area',
      value: 'userZone',
      type: 'select',
    },
    {
      title: 'Amateur Pro Status',
      value: 'userAmateur',
      type: 'select',
    },
  ],
  peopleNumbers: ALL_NUMBERS.map((itm) => {
    return { ...itm, value: getUserFieldName(itm.value) }
  }),
  horseMain: [
    {
      title: 'Breed',
      value: 'horseBreed',
      type: 'select',
    },
    {
      title: 'Height',
      value: 'horseHeight',
      type: 'select',
    },
    {
      title: 'Gender',
      value: 'horseGender',
      type: 'select',
    },
    {
      title: 'Gelding status and date',
      value: 'horseGeldingStatus',
      type: 'select',
    },
    {
      title: 'Date of Birth',
      value: 'horseDob',
      type: 'date',
    },
    {
      title: 'Discipline',
      value: 'horseDiscipline',
      type: 'select',
    },
    {
      title: 'Zone, Region, Area',
      value: 'horseZone',
      type: 'select',
    },
    {
      title: 'Coloring',
      value: 'horseColor',
      type: 'select',
    },
    {
      title: 'Country of Origin',
      value: 'horseCountry',
      type: 'select',
    },
  ],
  horseSecondary: [
    {
      title: 'Measurement card',
      value: 'horseMeasurementCard',
      type: 'paperwork',
    },
    {
      title: 'Coggins',
      value: 'horseCoggins',
      type: 'paperwork',
    },
    {
      title: 'Health certificate',
      value: 'horseHealthCertificate',
      type: 'paperwork',
    },
    {
      title: 'Rhinopneumonitis',
      value: 'horseRhinopneumonitis',
      type: 'paperwork',
    },
    {
      title: 'Influenza',
      value: 'horseInfluenza',
      type: 'paperwork',
    },
  ],
  horseNumbers: [
    {
      title: 'Microchip number',
      value: 'horseMicrochipNumber',
      type: 'tracking-number',
    },
    {
      title: 'DNA case number',
      value: 'horseDNACaseNumber',
      type: 'tracking-number',
    },
    {
      title: 'Passport number',
      value: 'horsePassportNumber',
      type: 'tracking-number',
    },
    ...ALL_NUMBERS.map((itm) => {
      return {
        ...itm,
        value: getHorseNumberFieldName(itm.value),
      }
    }),
  ],
}
